<template>
  <div>
    <router-view></router-view>
    <nav
      :class="
        count
          ? 'navbar navbar-default navbar-fixed-top hide-bg'
          : 'navbar navbar-default navbar-fixed-top show-bg'
      "
    >
      <div class="container-fluid container">
        <div class="navbar-header">
          <button
            type="button"
            class="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
            aria-expanded="false"
            ref="btn"
            @click="changeStatus"
          >
            <span class="sr-only"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a class="navbar-brand">
            <div class="logo">
              <h1>
                <img
                  :src="count ? '/static/black.png' : '/static/white.png'"
                  class="animated flipInX logoImg"
                  alt="南京小程序开发"
                  title="墨客云小程序开发"
                />
              </h1>
            </div>
          </a>
        </div>
        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul class="nav navbar-nav navbar-right animated">
            <li v-for="(item, index) in navData" :key="index">
              <router-link
                :to="item.url"
                :exact="item.url === '/' ? true : false"
                @click.native="changeUrl(item.url)"
                >{{ item.title }}</router-link
              >
            </li>
            <li @click="login" class="loginPlatform">
              <div class="login loginTrrace">登录开放平台</div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <user-footer></user-footer>
  </div>
</template>
<script>
import userFooter from './view/footer';
export default {
  name: 'App',
  components: {
    'user-footer': userFooter,
  },
  data() {
    return {
      navData: [],
      count: false,
      btn: false,
      clientWidth: '1000',
    };
  },
  mounted() {
    this.getNav();
    this.$nextTick(() => {
      window.addEventListener('scroll', this.onScroll);
    });
    setTimeout(() => {
      this.clientWidth = document.documentElement.clientWidth;
      if (this.$route.path == '/index' || this.$route.path == '/') {
        if (this.clientWidth <= 750) {
          this.styleChange(false);
        } else this.styleChange(true);
      } else this.styleChange(false);

      window.onresize = () => {
        this.clientWidth = document.documentElement.clientWidth;
        if (this.$route.path == '/index' || this.$route.path == '/') {
          if (document.documentElement.scrollTop >= 120)
            this.styleChange(false);
          else this.styleChange(true);
        } else {
          this.styleChange(false);
        }
      };

      $(window).on('scroll', () => {
        if (document.documentElement.scrollTop >= 120) {
          this.styleChange(false);
        } else {
          if (this.$route.path == '/index' || this.$route.path == '/') {
            this.$refs.btn.getAttribute('aria-expanded') == 'true'
              ? this.styleChange(false)
              : this.styleChange(true);
          } else this.styleChange(false);
        }
      });
    }, 800);
  },

  methods: {
    login() {
      window.open('https://open.mokyun.com/login');
    },
    onScroll() {
      let scrolled =
        document.documentElement.scrollTop || document.body.scrollTop;
    },
    // 当页面缩小时点击button判断显示/隐藏导航
    changeStatus() {
      if (this.$route.path == '/index' || this.$route.path == '/') {
        if (this.$refs.btn.getAttribute('aria-expanded') == 'false') {
          this.styleChange(false);
        } else {
          document.documentElement.scrollTop >= 120
            ? this.styleChange(false)
            : this.styleChange(true);
        }
      } else {
        this.styleChange(false);
      }
    },
    //获取导航栏
    getNav() {
      this.navData = [
        {
          title: '首页',
          url: '/',
        },
        {
          title: '解决方案',
          url: '/scheme',
        },
        {
          title: '案例展示',
          url: '/show',
        },
        {
          title: '实验室',
          url: '/laboratory',
        },
        {
          title: '联系我们',
          url: '/contact',
        },
        {
          title: '加入我们',
          url: '/join',
        },
      ];
    },
    // 路由切换
    changeUrl(path) {
      $('#bs-example-navbar-collapse-1').removeClass('in');
      if (path == '/index') {
        if (this.$refs.btn.getAttribute('aria-expanded') == 'true') {
          this.styleChange(false);
        } else {
          this.styleChange(true);
        }
      } else if (path == '/') {
        this.title = '墨客云科技-为科技发声';
        if (this.$refs.btn.getAttribute('aria-expanded') == 'true')
          this.styleChange(false);
        else this.styleChange(true);
      } else {
        this.styleChange(false);
        if (path == '/scheme') this.title = '墨客云科技-解决方案';
        if (path == '/show') this.title = '墨客云科技-案例展示';
        if (path == '/action') this.title = '墨客云科技-服务';
        if (path == '/laboratory') this.title = '墨客云科技-实验室';
        if (path == '/contact') this.title = '墨客云科技-联系我们';
        if (path == '/join') this.title = '墨客云科技-加入我们';
      }
    },
    // 导航样式改变
    styleChange(count) {
      if (!(this.$route.path === '/' || this.$route.path === '/index')) {
        this.count = true;
        return;
      }
      if (this.clientWidth <= 750) {
        this.count = true;
      } else {
        if (count) this.count = false;
        else this.count = true;
      }
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
body {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

#app {
  color: #2c3e50;
  width: 100%;
}
.show-bg {
  background: rgba(0, 0, 0, 0) !important;
  border-bottom: 0 solid #fff !important;
}
.hide-bg {
  box-shadow: 0px 8px 38px rgba(120, 114, 169, 0.15);
  border-bottom: 1px solid #fff;
}
.navbar-default {
  width: 100%;
  z-index: 999;
  /* padding: 6px 0; */
}
.navbar {
  min-height: 38px !important;
}
.navbar-header a {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.navbar-header .logo img {
  vertical-align: none;
  width: 200px;
}
.navbar-header a h1 {
  margin: 0;
  align-items: center;
}
.loginPlatform {
  /* margin-left: 16px; */
  margin-top: -25px;
  transform: translateY(80%);
}
.show-bg ul li a {
  color: #fff !important;
}
.hide-bg ul li a {
  color: #676767;
}
.show-bg button .icon-bar {
  background: #fff !important;
}

ul li {
  /* height: 50px;
  line-height: 50px; */
  padding: 0 10px;
}
ul li a {
  height: 50px;
  /* line-height: 50px; */
  /* background: black; */
  text-decoration: none;
  padding: 15px 0 !important;
}
ul li a:link {
  text-decoration: none;
}
ul li a:visited {
  text-decoration: none;
}
ul li a:active {
  text-decoration: none;
}
.show-bg ul li a:hover {
  color: #fff;
}
.hide-bg ul li a:hover {
  color: #5d84f3;
  /*transition: all .5s;*/
}
ul li a:hover {
  text-decoration: none;
}
.show-bg ul li .router-link-active {
  border-bottom: 4px solid #fff;
  color: #fff;
}
.hide-bg ul li .router-link-active {
  border-bottom: 4px solid #5d84f3;
  color: #5d84f3;
  /*transition: all .5s;*/
}
ul li .router-link-active {
  border-bottom: 4px solid #5d84f3;
  border-radius: 1px 1px 1px 1px;
  /* padding: 1.1em 0; */
}

.hide-bg ul li .loginTrrace {
  background: #779aff;
  color: #fff !important;
  cursor: pointer;
  padding: 8px;
  border: 1px solid #fff;
  /* margin-top: -25px;
		transform: translateY(80%); */
  text-align: center;
}
.hide-bg ul li .loginTrrace:hover {
  background: #779aff !important;
  color: white;
}

.show-bg ul li .loginTrrace {
  /* background: #779aff; */
  border: 1px solid #fff;
  color: #fff !important;
  cursor: pointer;
  padding: 8px;
  /* margin-top: 5px; */
  text-align: center;
}
.show-bg ul li .loginTrrace:hover {
  /* background: #779aff !important; */
  color: white;
}
@media (max-width: 992px) {
  .jq22-container .moudelBox .carousel .carousel-control.right {
    right: -35px !important;
  }
  .jq22-container .moudelBox .carousel .carousel-control.left {
    left: -35px !important;
  }
}
@media (min-width: 768px) {
  .navbar {
    border-radius: 0;
  }
}
@media (max-width: 768px) {
  ul li .router-link-active {
    padding: 0.6em 0;
  }
  .loginPlatform {
    margin-left: 0px;
  }
  .navbar {
    padding-bottom: 0px !important;
  }
  .navbar .navbar-header button {
    padding: 6px 7px;
    margin-top: 12px;
  }
  .navbar .navbar-header button .icon-bar {
    width: 18px;
  }
  ul li a {
    height: 35px;
    padding: 6px 0 !important;
  }
  .navbar-default .collapse {
    padding-bottom: 30px;
  }

  ul li {
    height: 45px;
    /* line-height: 50px; */
    padding: 0 10px;
  }
}

@media only screen and (max-width: 768px) and (min-width: 578px) {
  .navbar .logo h1 img {
    width: 180px;
  }
}

@media only screen and (max-width: 578px) and (min-width: 458px) {
  .navbar .logo h1 img {
    width: 160px;
  }
}

@media only screen and (max-width: 458px) and (min-width: 318px) {
  .navbar .logo h1 img {
    width: 130px;
  }
}

@media (max-width: 318px) {
  .navbar .logo h1 img {
    width: 100px;
  }
}

@media (min-width: 1200px) {
  .container-fluid {
    width: 85% !important;
  }
}

@media only screen and (max-width: 992px) and (min-width: 896px) {
  .navbar-default .container-fluid {
    width: 870px !important;
  }
}
@media only screen and (max-width: 896px) and (min-width: 830px) {
  .navbar-default .container-fluid {
    width: 815px !important;
  }
}
@media only screen and (max-width: 830px) and (min-width: 768px) {
  ul li {
    padding: 0 6px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue